import { render, staticRenderFns } from "./InquiryLetterDialog.vue?vue&type=template&id=10a209a7&scoped=true"
import script from "./InquiryLetterDialog.vue?vue&type=script&lang=js"
export * from "./InquiryLetterDialog.vue?vue&type=script&lang=js"
import style0 from "./InquiryLetterDialog.vue?vue&type=style&index=0&id=10a209a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a209a7",
  null
  
)

export default component.exports